import { ControlledInput } from '@/components/controlled';
import { useFormContext } from 'react-hook-form';
import { Label } from '@/components/ui';
import { TProps } from '..';

const FormContentCreateOrEditCreatorPaymentMethodPaypal = ({ fieldNames, readonly = false }: TProps) => {

  const { control } = useFormContext();

  return (
    <div className='space-y-4'>
      <div className='flex flex-col gap-2'>
        <Label>
          Email
        </Label>
        <ControlledInput
          maxLength={100}
          disabled={readonly}
          control={control}
          name={fieldNames.paymentInfo.email}
          placeholder={'Email du contact'} />
      </div>
    </div>
  );

};

export default FormContentCreateOrEditCreatorPaymentMethodPaypal;
